// extracted by mini-css-extract-plugin
export var backgroundImage = "HeroBanner-module--backgroundImage--6794c";
export var block = "HeroBanner-module--block--e4830";
export var doubleTextBlock = "HeroBanner-module--doubleTextBlock--ed121";
export var gradient = "HeroBanner-module--gradient--b2caa";
export var header = "HeroBanner-module--header--ec166";
export var heading = "HeroBanner-module--heading--a88db";
export var hero = "HeroBanner-module--hero--6656e";
export var hyphens = "HeroBanner-module--hyphens--50c1d";
export var inverted = "HeroBanner-module--inverted--1cb60";
export var label = "HeroBanner-module--label--c616a";
export var overlay = "HeroBanner-module--overlay--a58dd";
export var ratio_5_7 = "HeroBanner-module--ratio_5_7--27dd8";